import * as React from "react";
import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentLeadTimeOverview } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentLeadTimeViews";
export const InsightsReportDeploymentLeadTimeHelp = () => (<>
        <CommonInsightsDeploymentLeadTimeOverview /> <CommonInsightsReportHelp />
    </>);
